export default {
    getPapers: state => {
        return state.papers
    },
    getPaperById: state => id => {
        return state.papers.find(paper => paper.id == id)
    }
}
